var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTwitt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 17,
    viewBox: "0 0 19 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.08031 16C8.06771 16.1 10.9686 14.9876 13.1232 12.9159C15.2778 10.8441 16.5031 7.98907 16.5203 5.00005C17.198 4.16146 17.7011 3.19588 18.0003 2.16005C18.0459 1.99287 17.9892 1.81449 17.8553 1.70441C17.7215 1.59433 17.5355 1.57305 17.3803 1.65005C16.6534 1.99998 15.7842 1.84707 15.2203 1.27005C14.5111 0.493378 13.5175 0.0370087 12.4663 0.00498011C11.415 -0.0270484 10.3955 0.367994 9.64031 1.10005C8.59927 2.10824 8.16284 3.58832 8.49031 5.00005C5.14031 5.20005 2.84031 3.61005 1.00031 1.43005C0.887358 1.30213 0.709458 1.25312 0.546933 1.30512C0.384408 1.35713 0.268015 1.50032 0.250308 1.67005C-0.467576 5.65221 1.36717 9.66074 4.85031 11.72C3.70994 13.0279 2.10852 13.8447 0.380308 14C0.190488 14.0315 0.0416841 14.1802 0.0100516 14.37C-0.0215808 14.5598 0.0709577 14.7487 0.240308 14.84C1.74383 15.5914 3.39954 15.9882 5.08031 16Z",
    fill: "#637381"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitt);
export default __webpack_public_path__ + "static/media/twitt.6ee9be0a482f3587995531729aaaf47f.svg";
export { ForwardRef as ReactComponent };